// Sidebar toggle: on desktop it collapses (icons only), on mobile it slides.
import { store } from './store.js';

const DESKTOP_BREAKPOINT = 992; // lg in Bootstrap

const isDesktop = () => window.innerWidth >= DESKTOP_BREAKPOINT;

export function initSidebar() {
	const html = document.documentElement;

	const sidebar = document.querySelector('.app-sidebar');

	const toggle = () => {
		if (isDesktop()) {
			const collapsed = html.classList.toggle('sidebar-collapsed');
			store.set('genus-sidebar-collapsed', collapsed ? 'true' : 'false');
			// Collapsing with the mouse still on the panel: mute hover-expand until
			// the mouse leaves once, so the sidebar actually closes to the rail
			// instead of staying open as an overlay.
			if (collapsed && sidebar && sidebar.matches(':hover')) sidebar.classList.add('sidebar-hover-muted');
		} else {
			html.classList.toggle('sidebar-open');
		}
	};

	const close = () => html.classList.remove('sidebar-open');

	if (sidebar) sidebar.addEventListener('mouseleave', () => sidebar.classList.remove('sidebar-hover-muted'));

	document.querySelectorAll('[data-sidebar-toggle]').forEach((btn) => btn.addEventListener('click', toggle));
	document.querySelectorAll('[data-sidebar-close]').forEach((el) => el.addEventListener('click', close));

	// Close the mobile sidebar when resizing up to desktop
	window.addEventListener('resize', () => {
		if (isDesktop()) close();
	});
}
